import { get, remove, post, put } from '../services/common/common.service';

import { customersEndPoints } from '../constants/endpoint';

//Accounting Group Smart Seach - POST API to fetch the data as per payload
export const fetchAccountingGroupsData = (payload) => {
  return post(customersEndPoints.accountingGroup, payload);
};

//Get Customer Details to Display the data on Display Page. - GET API to fetch the data as per payload
export const byGlobalCustomersNo = (payload) => {
  return get(
    `${customersEndPoints.customersByGlobalCustomersNo}?globalCustomerNumber=${payload}`
  );
};

//Get Customers List On Grid - GET API to fetch the data as per payload
export const byMultipleInputs = (payload) => {
  return post(customersEndPoints.customersByMultipleInputs, payload);
};

//Get Customer Details to Display the data on Display Page. - GET API to fetch the data as per payload
export const getDetailsByCostomerId = (payload) => {
  return get(
    `${customersEndPoints.customersDetailsById}?customerId=${payload}`
  );
};

//Get Address Details to Display the data on Display Page. - GET API to fetch the data as per payload
export const getAddressDetailsByCostomerId = (payload) => {
  return get(
    `${customersEndPoints.customersAddressDetailsById}?psCustomerCode=${payload.psCustomerCode}&addressSequenceNum=${payload.addressSequenceNum}`
  );
};

//Get Customer History to Display the data on Display Page. - GET API to fetch the data as per payload
export const getCustomerHistory = (payload) => {
  return get(
    `${customersEndPoints.customerHisotry}?customerId=${payload.customerId}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`
  );
};

//Get Customer Children to Display the data on Display Page. - GET API to fetch the data as per payload
export const getCustomerChildren = (payload) => {
  return get(
    `${customersEndPoints.customerChildren}?customerId=${payload.customerId}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`
  );
};

//Get Customer Notes to Display the data on Display Page. - GET API to fetch the data as per payload
export const getCustomerNotes = (payload) => {
  return get(
    `${customersEndPoints.customerNotes}?customerId=${payload.customerId}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`
  );
};

//Add Customer Notes to Display the data on Display Page. - GET API to fetch the data as per payload
export const addCustomerNotes = (payload) => {
  return post(customersEndPoints.customerNotes, payload);
};

//Remove Customer Notes to Display the data on Display Page. - GET API to fetch the data as per payload
export const deleteCustomerNotes = (payload) => {
  return remove(
    `${customersEndPoints.customerNotes}?customerId=${payload.customerId}&customerNoteId=${payload.customerNoteId}`
  );
};

//Get Customer Entitlement Summary Data.
export const bySearchEntitlementSummary = (payload) => {
  return post(customersEndPoints.customerEntitlementSummary, payload);
};

export const bySearchCustomerSite = (payload) => {
  return post(customersEndPoints.customerSites, payload);
};

//Get Order Number List For Smart Search
export const orderNumberSmartSearch = (payload) => {
  return get(
    `${customersEndPoints.orderNumberSmartSearch}?searchText=${payload.searchText}&recordCount=${payload.recordCount}`
  );
};

//Get Site IDs List For Smart Search
export const siteIDSmartSearch = (payload) => {
  return get(
    `${customersEndPoints.siteIDSmartSearch}?searchText=${payload.searchText}&recordCount=${payload.recordCount}`
  );
};

//Get Order Numbers
export const getCustomersBy_OrderNumber_SiteID = (payload) => {
  return post(customersEndPoints.salesOrderCustomerSearch, payload);
};

//Customer Billing Tab - Get Customer Bill Notes
export const fetchCustomerBillNotes = (payload) => {
  return get(
    `${customersEndPoints.customerBillNotes}?customerId=${payload.customerId}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`,
    payload
  );
};

//Customer Billing Tab - Get Customer Bills
export const fetchCustomerBillingBills = (payload) => {
  return get(
    `${customersEndPoints.customerBillingBills}?customerId=${payload.customerId}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`,
    payload
  );
};

//Update Serialized Flag for ADMIN user.
export const updateCustomersInfo = (payload) => {
  return put(customersEndPoints.updateCustomersInfo, payload);
};

//Bills - Bill Tab - Get Customer Bill Details
export const getViewBillData = (payload) => {
  return get(`${customersEndPoints.viewBill}?customerBillId=${payload}`);
};

//Send Entitlement Summary email
export const sendEntitlementSummaryEmail = (payload) => {
  return post(customersEndPoints.sendCustomerEntitlementSummaryEmail, payload);
};